import { status } from 'skin/event/status';

const del = (obj, ms, story, data, d, action) => {
	const key = story.s.pacMaster.table.pacProd.row
	data.delRow(ms, 'pacProd', key)
	return status.ignore
}
export default del;
